import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BalloonTalk } from '../shared/BalloonTalk';
import { Dialog } from '../shared/dialog/Dialog';
import { Photo } from '../shared/Photo';

export const ChatHintDialog: React.FC = () => {
  const { t } = useTranslation('chat');
  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;

          h1 {
            color: #4d3906;
            font-size: 20px;
            text-align: center;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .photo {
            width: 278px;
            height: 180px;
            margin: 32px auto;
            position: relative;
          }
          .balloon {
            display: flex;
            justify-content: center;
            position: absolute;
            top: -8px;
            left: 0;
            right: 0;
            filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0.1));
          }
          .left-rotate {
            transform: rotate(-2deg);
          }
          /* less than iPhone6/7/8 display size */
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 18px;
            }
            .photo {
              width: 214px;
              height: 140px;
            }
          }
        `}
      >
        <h1>{t('help')}</h1>
        <section>
          <div className="photo left-rotate">
            <Photo
              srcSet={`
              /images/chat/img_talk_tutorial_01-2x.jpg 2x,
              /images/chat/img_talk_tutorial_01.jpg 1x
              `}
            />
            <div className="balloon">
              <BalloonTalk text={t('hint_balloon_text')} />
            </div>
          </div>
          <p>{t('help_desc_01')}</p>
          <p>{t('help_desc_02')}</p>
        </section>
      </div>
    </Dialog>
  );
};
